import store from '@/core/store';
import { RouteRecordRaw } from 'vue-router';

const followUpOverview = () => import('@/modules/follow-up/pages/FollowUpOverview.vue');

const candidateDetails = () => import('@/modules/candidates/components/candidate-details/CandidateDetails.vue');

const matchesOverview = () => import('@/modules/follow-up/components/FollowUpMatchesOverview.vue');
const journeysOverview = () => import('@/modules/follow-up/components/FollowUpJourneysOverview.vue');
const generalOverview = () => import('@/modules/follow-up/components/FollowUpGeneralOverview.vue');

const FOLLOW_UP_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'FollowUpOverview',
      component: followUpOverview,
      redirect: { name: 'FollowUpMatchesOverview' },
      children: [
         {
            path: 'matches',
            name: 'FollowUpMatchesOverview',
            component: matchesOverview,
            meta: {
               id: 1,
            },
            children: [
               {
                  path: ':id',
                  name: 'FollowUpMatchesOverviewDetail',
                  component: candidateDetails,
               },
            ],
         },
         {
            path: 'journeys',
            name: 'FollowUpJourneysOverview',
            component: journeysOverview,
            beforeEnter: (to, from, next) => {
               const { query } = to;
               if (!query.sort) return next({ ...to, query: { ...query, sort: '-journey_updated_at', page: '1', per_page: '25' } });

               return next();
            },
            meta: {
               id: 2,
            },
            children: [
               {
                  path: ':id',
                  name: 'FollowUpJourneysOverviewDetail',
                  component: candidateDetails,
                  beforeEnter: (to, from, next) => {
                     const { query } = to;
                     if (!query.sort) return next({ ...to, query: { ...query, sort: '-journey_updated_at', page: '1', per_page: '25' } });

                     return next();
                  },
               },
            ],
         },
         {
            path: 'general',
            name: 'FollowUpGeneralOverview',
            component: generalOverview,
            meta: {
               id: 3,
            },
            beforeEnter: (to, from, next) => {
               store.getters.isLite ? next({ name: 'FollowUpJourneysOverview' }) : next();
            },
            children: [
               {
                  path: ':id',
                  name: 'FollowUpGeneralOverviewDetail',
                  component: candidateDetails,
                  beforeEnter: (to, from, next) => {
                     const { query } = to;
                     if (!query.sort) return next({ ...to, query: { ...query, sort: 'expired_at', page: '1', per_page: '25' } });

                     return next();
                  },
               },
            ],
         },
      ],
   },
];

export { FOLLOW_UP_ROUTES };
